<header class="border-b border-slate-200 bg-white">
  <div class="mx-auto w-full max-w-[82rem] px-4 sm:px-6 lg:px-10 xl:px-16 py-4">
    <div class="grid grid-cols-[auto_1fr_auto] items-center">
      <a
        [routerLink]="paths.segments('home')"
        class="flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50 rounded-md"
        [attr.aria-label]="'COMMON.HOME_ARIA' | translate"
      >
        <img
          src="/logo_phrase.png"
          alt="Logo Unelya"
          class="h-9 w-auto object-contain"
          width="140"
          height="36"
        />
      </a>

      <nav class="hidden md:flex items-center justify-center gap-6 text-sm">
        <a
          *ngFor="let item of items"
          [routerLink]="paths.segments(item.routeKey)"
          routerLinkActive="text-blue-700 underline"
          [routerLinkActiveOptions]="{ exact: item.routeKey === 'home' }"
          class="text-slate-700 hover:text-slate-900 underline-offset-4 hover:underline transition-colors"
        >
          {{ item.labelKey | translate }}
        </a>
      </nav>

      <!-- Desktop : bouton candidat (dropdown) | Mobile : menu burger -->
      <div class="flex items-center justify-end gap-3">
        <!-- Desktop : langue (à gauche du bouton candidat) -->
        <div class="relative hidden md:block" #langMenu>
          <button
            type="button"
            (click)="toggleLangMenu()"
            class="inline-flex items-center gap-1 rounded-md px-1.5 py-1 text-sm text-slate-700 hover:text-slate-900 hover:bg-slate-50 transition-colors cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50"
            [attr.aria-expanded]="langMenuOpen"
            [attr.aria-label]="'HEADER.CHOOSE_LANGUAGE' | translate"
          >
            <img [src]="lang === 'en' ? '/flags/gb.svg' : '/flags/fr.svg'" [alt]="(lang === 'en' ? 'COMMON.ENGLISH' : 'COMMON.FRENCH') | translate" class="w-5 h-[13px] object-cover" />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="size-4 text-slate-500 transition-transform duration-200"
              [class.rotate-180]="langMenuOpen"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </button>

          <div
            *ngIf="langMenuOpen"
            class="absolute right-0 mt-2 w-44 rounded-lg border border-slate-200 bg-white shadow-sm overflow-hidden"
            role="menu"
          >
            <button
              type="button"
              (click)="setLang('fr')"
              class="cursor-pointer w-full flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 text-left"
              role="menuitem"
            >
              <span class="inline-flex items-center gap-2">
                <img src="/flags/fr.svg" alt="" class="w-5 h-[13px] object-cover" aria-hidden="true" />
                <span>{{ 'COMMON.FRENCH' | translate }}</span>
              </span>
              <span *ngIf="lang === 'fr'" class="text-blue-700 font-semibold">✓</span>
            </button>
            <button
              type="button"
              (click)="setLang('en')"
              class="cursor-pointer w-full flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 text-left"
              role="menuitem"
            >
              <span class="inline-flex items-center gap-2">
                <img src="/flags/gb.svg" alt="" class="w-5 h-[13px] object-cover" aria-hidden="true" />
                <span>{{ 'COMMON.ENGLISH' | translate }}</span>
              </span>
              <span *ngIf="lang === 'en'" class="text-blue-700 font-semibold">✓</span>
            </button>
          </div>
        </div>

        <!-- Desktop : dropdown candidat -->
        <div class="relative hidden md:block" #candidatDropdown>
          <button
            type="button"
            (click)="toggleCandidatMenu()"
            class="inline-flex items-center gap-1 rounded-md border border-slate-300 bg-white px-2.5 py-2 text-slate-700 hover:bg-slate-50 transition-colors cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50"
            [attr.aria-label]="'HEADER.CANDIDATE_MENU_ARIA' | translate"
            [attr.aria-expanded]="candidatMenuOpen"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="size-4 shrink-0"
              aria-hidden="true"
            >
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
              <polyline points="10 17 15 12 10 7" />
              <line x1="15" y1="12" x2="3" y2="12" />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="size-4 shrink-0 transition-transform duration-200"
              [class.rotate-180]="candidatMenuOpen"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </button>
          <div
            *ngIf="candidatMenuOpen"
            class="absolute right-0 mt-2 w-48 rounded-lg border border-slate-200 bg-white shadow-sm overflow-hidden"
            role="menu"
          >
            <div class="px-4 pt-3 pb-2">
              <p class="text-xs uppercase tracking-wider text-slate-500 font-medium">
                {{ 'HEADER.BRAND' | translate }}
              </p>
            </div>
            <div class="h-px bg-slate-200 mx-4" aria-hidden="true"></div>
            <a
              [href]="paths.universityPortalUrl()"
              target="_blank"
              rel="noopener noreferrer"
              (click)="closeCandidatMenu()"
              class="flex items-center gap-2 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50"
              role="menuitem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="size-4 text-slate-500"
                aria-hidden="true"
              >
                <path d="M2 10l10-5 10 5-10 5-10-5Z" />
                <path d="M6 12v5c0 1 3 3 6 3s6-2 6-3v-5" />
              </svg>
              <span>{{ 'HEADER.UNIVERSITY_PORTAL' | translate }}</span>
            </a>
            <a
              [href]="paths.studentPortalUrl()"
              target="_blank"
              rel="noopener noreferrer"
              (click)="closeCandidatMenu(); consent.trackStudentPortalClick()"
              class="flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-blue-700 hover:bg-blue-50"
              role="menuitem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="size-4"
                aria-hidden="true"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <span>{{ 'HEADER.STUDENT_PORTAL' | translate }}</span>
            </a>
            <div class="h-px bg-slate-200 mx-4" aria-hidden="true"></div>
            <button
              type="button"
              (click)="openSupportEmail()"
              class="flex w-full cursor-pointer items-center gap-2 px-4 py-2.5 text-left text-sm text-slate-700 hover:bg-slate-50"
              role="menuitem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="size-4 text-slate-500"
                aria-hidden="true"
              >
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="M3 7l9 6 9-6" />
              </svg>
              <span>{{ 'HEADER.CONTACT' | translate }}</span>
            </button>
          </div>
        </div>

        <!-- Mobile : burger + panneau latéral -->
        <div class="relative md:hidden" #mobileMenuContainer>
          <button
            type="button"
            (click)="toggleMobileMenu()"
            class="inline-flex items-center justify-center rounded-md border border-slate-300 bg-white p-2.5 text-slate-700 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50"
            [attr.aria-label]="'HEADER.OPEN_MENU' | translate"
            [attr.aria-expanded]="mobileMenuOpen"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="size-6"
              aria-hidden="true"
            >
              <path d="M4 6h16" />
              <path d="M4 12h16" />
              <path d="M4 18h16" />
            </svg>
          </button>
          <ng-container *ngIf="mobileMenuOpen">
            <!-- Overlay -->
            <div
              class="fixed inset-0 bg-slate-900/40 z-40"
              (click)="closeMobileMenu()"
              aria-hidden="true"
            ></div>
            <!-- Panneau latéral -->
            <aside
              class="fixed inset-y-0 right-0 z-50 w-80 max-w-[calc(100vw-3rem)] bg-white border-l border-slate-200 shadow-xl flex flex-col"
              role="dialog"
              aria-modal="true"
            >
              <!-- En-tête -->
              <div class="flex items-center justify-between px-4 py-3 border-b border-slate-200">
                <div class="flex items-center gap-2">
                  <span class="text-sm font-medium text-slate-900">{{ 'HEADER.MENU' | translate }}</span>
                </div>
                <button
                  type="button"
                  (click)="closeMobileMenu()"
                  class="inline-flex items-center justify-center rounded-full p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
                  [attr.aria-label]="'HEADER.CLOSE_MENU' | translate"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="size-5"
                    aria-hidden="true"
                  >
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                  </svg>
                </button>
              </div>

              <!-- Contenu -->
              <div class="flex-1 overflow-y-auto px-4 py-3 space-y-6">
                <!-- Navigation -->
                <section>
                  <h2 class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
                    {{ 'HEADER.NAVIGATION' | translate }}
                  </h2>
                  <nav class="space-y-1">
                    <a
                      *ngFor="let item of items"
                      [routerLink]="paths.segments(item.routeKey)"
                      routerLinkActive="bg-blue-50 text-blue-700"
                      [routerLinkActiveOptions]="{ exact: item.routeKey === 'home' }"
                      (click)="closeMobileMenu()"
                      class="block rounded-md px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                    >
                      {{ item.labelKey | translate }}
                    </a>
                  </nav>
                </section>

                <!-- Portail candidat / université -->
                <section>
                  <h2 class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
                    {{ 'HEADER.BRAND' | translate }}
                  </h2>
                  <div class="space-y-1">
                    <a
                      [href]="paths.universityPortalUrl()"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="closeMobileMenu()"
                      class="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4 text-slate-500">
                        <path d="M2 10l10-5 10 5-10 5-10-5Z" /><path d="M6 12v5c0 1 3 3 6 3s6-2 6-3v-5" />
                      </svg>
                      {{ 'HEADER.UNIVERSITY_PORTAL' | translate }}
                    </a>
                    <a
                      [href]="paths.studentPortalUrl()"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="closeMobileMenu(); consent.trackStudentPortalClick()"
                      class="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-blue-700 hover:bg-blue-50"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
                      </svg>
                      {{ 'HEADER.STUDENT_PORTAL' | translate }}
                    </a>
                  </div>
                </section>

                <!-- Aide -->
                <section>
                  <h2 class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
                    {{ 'HEADER.HELP' | translate }}
                  </h2>
                  <button
                    type="button"
                    (click)="openSupportEmail()"
                    class="flex w-full cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4 text-slate-500">
                      <rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" />
                    </svg>
                    {{ 'HEADER.CONTACT' | translate }}
                  </button>
                </section>

                <!-- Langue -->
                <section>
                  <h2 class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
                    {{ 'HEADER.LANGUAGE' | translate }}
                  </h2>
                  <div class="relative" #mobileLangMenu>
                    <button
                      type="button"
                      (click)="toggleLangMenu()"
                      class="cursor-pointer inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-2 text-xs text-slate-700 shadow-sm hover:bg-slate-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
                      [attr.aria-expanded]="langMenuOpen"
                      [attr.aria-label]="'HEADER.CHOOSE_LANGUAGE' | translate"
                    >
                      <img [src]="lang === 'en' ? '/flags/gb.svg' : '/flags/fr.svg'" [alt]="(lang === 'en' ? 'COMMON.ENGLISH' : 'COMMON.FRENCH') | translate" class="w-5 h-[13px] object-cover" />
                      <span class="font-medium">{{ (lang === 'en' ? 'COMMON.ENGLISH' : 'COMMON.FRENCH') | translate }}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-3.5 text-slate-500 transition-transform duration-200" [class.rotate-180]="langMenuOpen" aria-hidden="true">
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </button>
                    <div
                      *ngIf="langMenuOpen"
                      class="absolute left-0 bottom-full mb-2 w-44 rounded-lg border border-slate-200 bg-white shadow-sm overflow-hidden"
                      role="menu"
                    >
                      <button
                        type="button"
                        (click)="setLang('fr')"
                        class="cursor-pointer w-full flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 text-left"
                        role="menuitem"
                      >
                        <span class="inline-flex items-center gap-2">
                          <img src="/flags/fr.svg" alt="" class="w-5 h-[13px] object-cover" aria-hidden="true" />
                          <span>{{ 'COMMON.FRENCH' | translate }}</span>
                        </span>
                        <span *ngIf="lang === 'fr'" class="text-blue-700 font-semibold">✓</span>
                      </button>
                      <button
                        type="button"
                        (click)="setLang('en')"
                        class="cursor-pointer w-full flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 text-left"
                        role="menuitem"
                      >
                        <span class="inline-flex items-center gap-2">
                          <img src="/flags/gb.svg" alt="" class="w-5 h-[13px] object-cover" aria-hidden="true" />
                          <span>{{ 'COMMON.ENGLISH' | translate }}</span>
                        </span>
                        <span *ngIf="lang === 'en'" class="text-blue-700 font-semibold">✓</span>
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </aside>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</header>
